import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";

import Navigation from "../components/Navigation";
import Hero from "../components/Hero";
import FeaturedWork from "../components/FeaturedWork";
import Categories from "../components/Categories";
import FilmsSection from "../components/FilmSection";
import MasonryGallery from "../components/MasonryGallery";
import AboutSection from "../components/AboutSection";
import ContactSection from "../components/ContactSection";
import Footer from "../components/Footer";
import WeddingsSection from "../components/WeddingsSection";

/* Custom Cursor */
const CustomCursor = () => {
  const [position, setPosition] = useState({ x: 0, y: 0 });
  const [isHovering, setIsHovering] = useState(false);

  useEffect(() => {
    const handleMouseMove = (e) =>
      setPosition({ x: e.clientX, y: e.clientY });

    const handleMouseOver = (e) =>
      setIsHovering(!!e.target.closest("button, a, .cursor-hover"));

    window.addEventListener("mousemove", handleMouseMove);
    window.addEventListener("mouseover", handleMouseOver);
    return () => {
      window.removeEventListener("mousemove", handleMouseMove);
      window.removeEventListener("mouseover", handleMouseOver);
    };
  }, []);

  return (
    <div
      className="fixed pointer-events-none z-[9999] mix-blend-difference hidden md:block"
      style={{
        left: position.x,
        top: position.y,
        transform: "translate(-50%, -50%)",
      }}
    >
      <div
        className={`rounded-full bg-white transition-all duration-300 ${isHovering ? "w-7 h-7 opacity-50" : "w-3 h-3 opacity-100"
          }`}
      />
    </div>
  );
};

const HomePage = () => {
  const [scrollY, setScrollY] = useState(0);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrollY(window.scrollY);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  /* 🔥 THIS FIXES /gallery → scroll */
  useEffect(() => {
    if (location.state?.scrollTo) {
      const el = document.getElementById(location.state.scrollTo);
      if (el) {
        const yOffset = -120;
        const y =
          el.getBoundingClientRect().top +
          window.pageYOffset +
          yOffset;

        setTimeout(() => {
          window.scrollTo({ top: y, behavior: "smooth" });
          window.history.replaceState({}, document.title);
        }, 200);
      }
    }
  }, [location]);
  const toddlerImages = ['assets/toddlers-webp/t1.webp',
    'assets/toddlers-webp/t7.webp', 'assets/toddlers-webp/t12.webp',
    'assets/toddlers-webp/t17.webp', 'assets/toddlers-webp/t25.webp',
    'assets/toddlers-webp/t31.webp', 'assets/toddlers-webp/t35.webp', 
    'assets/toddlers-webp/t39.webp', 'assets/toddlers-webp/t41.webp', 
    'assets/toddlers-webp/t47.webp', 'assets/toddlers-webp/t50.webp', 
    'assets/toddlers-webp/t52.webp', 'assets/toddlers-webp/t56.webp',
  ];
  const fashionImages = ['assets/fashion-webp/f10.webp', 
    'assets/fashion-webp/f19.webp', 
    'assets/fashion-webp/f9.webp', 
    'https://ik.imagekit.io/p3xaqnkci/tagteam/fashion/fashion-webp/f23.webp', 
    'https://ik.imagekit.io/p3xaqnkci/tagteam/fashion/fashion-webp/f27.webp', 
    'https://ik.imagekit.io/p3xaqnkci/tagteam/fashion/fashion-webp/f24.webp',
    'https://ik.imagekit.io/p3xaqnkci/tagteam/fashion/fashion-webp/f32.webp', 
    'https://ik.imagekit.io/p3xaqnkci/tagteam/fashion/fashion-webp/f38.webp', 
    'https://ik.imagekit.io/p3xaqnkci/tagteam/fashion/fashion-webp/f40.webp', 
    'https://ik.imagekit.io/p3xaqnkci/tr:f-auto,q-auto,w-1200/tagteam/fashion/f47.gif', 
    'https://ik.imagekit.io/p3xaqnkci/tr:f-auto,q-auto,w-1200/tagteam/fashion/f49.jpeg', 
    'https://ik.imagekit.io/p3xaqnkci/tagteam/fashion/fashion-webp/f44.webp', 
    'https://ik.imagekit.io/p3xaqnkci/tagteam/fashion/fashion-webp/f43.webp',
    'assets/fashion-webp/f36.webp',];
  return (
    <div className="bg-neutral-950 min-h-screen overflow-x-hidden" style={{ cursor: "none" }}>
      <CustomCursor />
      <Navigation scrollY={scrollY} />

      <Hero />
      <FeaturedWork />
      <Categories />

      <section id="films">
        <FilmsSection />
      </section>
      <section id="weddings">
        <WeddingsSection />
      </section>
      <MasonryGallery title="TagTeam Toddlers" subtitle="FAMILY PORTRAITS" images={toddlerImages} slug="gallery/toddler" />
      <MasonryGallery title="Fashion & Portraits" subtitle="EDITORIAL WORK" images={fashionImages} slug="gallery/fashion" />
      <section id="about">
        <AboutSection />
      </section>

      <section id="contact">
        <ContactSection />
      </section>

      <Footer />
    </div>
  );
};

export default HomePage;
